<template>
	<v-container fluid>
		<v-row >
			<v-col cols="12" md="3" sm="6" class="align-self-end">
				<VueCtkDateTimePicker
					id="inicio"
					v-model="filtros.inicio"
					:label="$t('Reports.IncidentReport.filters.from')"
					format="YYYY-MM-DD HH:mm"
					formatted="YYYY-MM-DD HH:mm"
					noHeader
					overlay
					:buttonNowTranslation="$t('Reports.IncidentReport.filters.now')"
					@input="getSeries()"
				/>
			</v-col>
			<v-col cols="12" md="3" sm="6" class="align-self-end">
				<VueCtkDateTimePicker
					id="fin"
					v-model="filtros.fin"
					:min-date="filtros.inicio"
					:label="$t('Reports.IncidentReport.filters.to')"
					format="YYYY-MM-DD HH:mm"
					formatted="YYYY-MM-DD HH:mm"
					noHeader
					overlay
					:buttonNowTranslation="$t('Reports.IncidentReport.filters.now')"
					@input="getSeries()"
				/>
			</v-col>
			<v-col cols="12" md="3" sm="6" class="align-self-end">
				<v-autocomplete
					v-model="filtros.idArea"
					:items="areas"
					item-value="idArea"
					item-text="nombre"
					:label="$t('Reports.IncidentReport.filters.area')"
					hide-details
					clearable
					@change="getSeries()"
				></v-autocomplete>
			</v-col>
			<v-col cols="12" md="3" sm="6" class="align-self-end d-flex justify-end">
				<v-tooltip bottom color="blue-grey darken-4">
					<template v-slot:activator="{ on, attrs }">
						<div v-bind="attrs" class="incident-language-control" v-on="on">
							<v-icon small color="primary" class="mr-2">mdi-translate</v-icon>
							<v-btn-toggle
								:value="currentLocale"
								mandatory
								dense
								class="incident-language-toggle"
								@change="setLocale"
							>
								<v-btn
									small
									value="es"
									class="incident-language-btn"
									:class="{ 'incident-language-btn--active': currentLocale === 'es' }"
									:aria-label="$t('Reports.IncidentReport.language.spanish')"
								>
									ES
								</v-btn>
								<v-btn
									small
									value="en"
									class="incident-language-btn"
									:class="{ 'incident-language-btn--active': currentLocale === 'en' }"
									:aria-label="$t('Reports.IncidentReport.language.english')"
								>
									EN
								</v-btn>
							</v-btn-toggle>
						</div>
					</template>
					<span class="white--text">{{ $t('Reports.IncidentReport.language.tooltip') }}</span>
				</v-tooltip>
			</v-col>
		</v-row>
		<v-row >
		  <v-expansion-panels>
			<v-expansion-panel>
				<v-expansion-panel-header>
					<div>
					<v-icon>mdi-target</v-icon> {{ $t('Reports.IncidentReport.filters.advanced') }}
					</div>
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<v-row>
						<!-- Este aparece si la empresa NO es Nyx -->
						<v-col v-if="nombreEmpresa !== 'Nyx'" cols="2" md="2" sm="2" class="mt-0 pt-0">
							<v-select
								v-model="filtros.bloqueoProduccion"
								:items="tipoIncidencias"
								item-value="id"
								:label="$t('Reports.IncidentReport.filters.incidentType')"
								hide-details
								:clearable="false"
								:disabled="true"
								@change="getSeries()"
							></v-select>
						</v-col>

						<!-- Este aparece solo si la empresa SÍ es Nyx -->
						<v-col cols="2" md="2" sm="2" class="mt-0 pt-0">
							<v-select
								v-model="filtros.instancias"
								:items="instancias"
								item-value="idMaquinaIns"
								item-text="nombre"
								:label="$t('Reports.IncidentReport.filters.machineInstance')"
								hide-details
								clearable
								@change="getSeries()"
							></v-select>
						</v-col>

						<v-col cols="2" md="2" sm="2" class="mt-0 pt-0">
							<v-select
								v-model="filtros.idOEEFactor"
								:items="oeeFactores"
								item-value="idOEEFactor"
								item-text="nombre"
								:label="$t('Reports.IncidentReport.filters.oeeFactor')"
								hide-details
								clearable
								@change="getSeries()"
							></v-select>
						</v-col>
						<v-col cols="2" md="2" sm="2" class="mt-0 pt-0">
							<v-autocomplete
								v-model="filtros.idParoTipo"
								:items="tipoParosFiltrados"
								item-value="idParoTipo"
								item-text="nombre"
								:label="$t('Reports.IncidentReport.filters.incidentReason')"
								hide-details
								clearable
								@change="changeParoTipo"
							></v-autocomplete>
						</v-col>
						<v-col cols="2" md="2" sm="2" class="mt-0 pt-0">
							<v-autocomplete
								v-model="filtros.idSubParoTipo"
								:items="subTipoParoFiltrados"
								item-value="idSubParoTipo"
								item-text="nombreSubParoTipo"
								:label="$t('Reports.IncidentReport.filters.incidentSubreason')"
								hide-details
								clearable
								@change="getSeries()"
							></v-autocomplete>
						</v-col>
						<v-col cols="2" md="2" sm="2" class="mt-0 pt-0">
							<v-autocomplete
								v-model="filtros.clave"
								:items="claves"
								item-value="idTrabajoOrden"
								item-text="clave"
								:label="$t('Reports.IncidentReport.filters.workOrder')"
								hide-details
								clearable
								@change="getSeries()"
							></v-autocomplete>
						</v-col>
						<v-col cols="2" md="2" sm="2" class="mt-0 pt-0">
							<v-autocomplete
								v-model="filtros.idArticuloProducir"
								:items="articulosProducir"
								item-value="idArticulo"
								item-text="nombre"
								:label="$t('Reports.IncidentReport.filters.itemToProduce')"
								hide-details
								clearable
								@change="getSeries()"
							></v-autocomplete>
						</v-col>
						<v-col cols="2" md="2" sm="2" class="mt-0 pt-0">
							<v-autocomplete
								v-model="filtros.idArticuloFase"
								:items="articulosFase"
								item-value="idArticulo"
								item-text="nombre"
								:label="$t('Reports.IncidentReport.filters.phaseItem')"
								hide-details
								clearable
								@change="getSeries()"
							></v-autocomplete>
						</v-col>
						<v-col cols="2" md="2" sm="2" class="mt-0 pt-0">
							<v-autocomplete
								v-model="filtros.idArticuloCodigo"
								:items="articulosCodigos"
								item-value="idArticulo"
								item-text="codigo"
								:label="$t('Reports.IncidentReport.filters.partNumber')"
								hide-details
								clearable
								@change="getSeries()"
							/>
						</v-col>
						<v-col cols="2" md="2" sm="2" class="mt-0 pt-0">
							<v-autocomplete
								v-model="filtros.idReporto"
								:items="operadores"
								item-value="idPersona"
								:item-text="nombrePersona"
								:label="$t('Reports.IncidentReport.filters.reportedBy')"
								hide-details
								clearable
								@change="getSeries()"
							></v-autocomplete>
						</v-col>
						<v-col cols="2" md="2" sm="2" class="mt-0 pt-0 mb-4">
							<v-autocomplete
								v-model="filtros.idResponsable"
								:items="personas"
								item-value="idPersona"
								:item-text="nombrePersona"
								:label="$t('Reports.IncidentReport.filters.responsiblePerson')"
								hide-details
								clearable
								@change="getSeries()"
							></v-autocomplete>
						</v-col>
						<v-col cols="2" md="2" sm="2" class="mt-0 pt-0 mb-4">
							<v-autocomplete
								v-model="filtros.idTipoParo"
								:items="tiposParos"
								item-value="id"
								item-text="value"
								:label="$t('Reports.IncidentReport.filters.stopType')"
								hide-details
								clearable
								@change="getSeries()"
							></v-autocomplete>
						</v-col>
					</v-row>
				</v-expansion-panel-content>
			</v-expansion-panel>
		  </v-expansion-panels>	
		</v-row>
		<div style="position: relative;">
			<div
				style="
				position: absolute;
				top: 8px;
				right: 120px; /* <- este valor ajusta la alineación exacta */
				font-weight: bold;
				font-size: 16px;
				z-index: 10;
				background: white;
				padding: 2px 6px;
				">
			</div>

			<apexchart
				type="bar"
				height="500"
				:options="chartOptions"
				:series="series"
			></apexchart>
		</div>
		<v-dialog v-model="dialogVisible" max-width="1400px">
			<v-card>
				<v-card-title class="headline">
				{{ $t('Reports.IncidentReport.dialog.relatedReports') }} - {{ selectedData.category }}
				</v-card-title>

				<v-card-text>
				<v-data-table
					:headers="headersFiltrados"
					:items="paros"
					:loading="loading"
					:loading-text="$t('Reports.IncidentReport.table.loading')"
					:items-per-page="10"
					:footer-props="{
					disableItemsPerPage: true,
					}"
					:disable-sort="true"
					:disable-pagination="loading"
				>
					<template v-slot:item.tipoIncidencia="{ item }">
					<div :class="item.tipoIncidencia === 'Paro' ? 'red--text font-weight-bold' : ''">
						{{ item.tipoIncidencia }}
					</div>
					</template>

					<template v-slot:item.motivoParo="{ item }">
					<div>
						<div class="font-weight-bold">{{ item.motivoParo }}</div>
						<div v-if="item.subMovitoParo">{{ item.subMovitoParo }}</div>
					</div>
					</template>

					<template v-slot:item.proceso="{ item }">
					<div>{{ item.proceso }}</div>
					</template>

					<template v-slot:item.reportadoPorOperadores="{ item }">
					<ul class="text-left pl-0">
						<li v-for="(op, i) in item.reportadoPorOperadores" :key="i">{{ op }}</li>
					</ul>
					</template>

					<template v-slot:item.maquina="{ item }">
					<div>
						{{ $t('Reports.IncidentReport.machine.brand') }}: {{ item.maquina.marca }}<br>
						{{ $t('Reports.IncidentReport.machine.model') }}: {{ item.maquina.modelo }}<br>
						{{ $t('Reports.IncidentReport.machine.code') }}: {{ item.maquina.codigo }}
					</div>
					</template>

					<template v-slot:item.actions="{ item }">
					<v-tooltip bottom color="black" class="white--text">
						<template v-slot:activator="{ on }">
						<v-icon
							v-on="on"
							small
							class="mr-2"
							@click="descargarPDF(item.idParo)"
						>
							mdi-file-download
						</v-icon>
						</template>
						<span class="white--text">{{ $t('Reports.IncidentReport.dialog.downloadPdf') }}</span>
					</v-tooltip>

					<v-tooltip bottom color="black" class="white--text">
						<template v-slot:activator="{ on }">
						<v-icon
							v-on="on"
							small
							class="mr-2"
							@click="verParoPreview(item.idParo)"
						>
							mdi-eye-outline
						</v-icon>
						</template>
						<span class="white--text">{{ $t('Reports.IncidentReport.dialog.viewPdf') }}</span>
					</v-tooltip>
					</template>
				</v-data-table>
				</v-card-text>

				<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click="dialogVisible = false">{{ $t('Reports.IncidentReport.dialog.close') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="previewVisible"
			max-width="90vw"
			max-height="90vh"
			persistent
			scrollable
		>
			<v-card style="height: 90vh; display: flex; flex-direction: column;">
			<v-card-title class="headline">
				{{ $t('Reports.IncidentReport.dialog.pdfPreview') }}
			</v-card-title>

			<v-card-text class="pa-0" style="flex: 1; position: relative;">
				<iframe
				v-if="previewUrl"
				:src="previewUrl"
				style="
					position: absolute;
					top: 0; left: 0;
					width: 100%;
					height: 100%;
					border: none;
				"
				></iframe>
			</v-card-text>

			<v-card-actions>
				<v-spacer />
				<v-btn text color="primary" @click="previewVisible = false">
				{{ $t('Reports.IncidentReport.dialog.close') }}
				</v-btn>
			</v-card-actions>
			</v-card>
		</v-dialog>

	</v-container>
</template>

<script>
import axios from "axios";
import {mapState} from "vuex";
export default {
	data() {
		return {
			tiposParos: [
				{
					id: 1,
					value: "Sensor",
				},
				{
					id: 2,
					value: "Manual",
				},
			],
			instancias: [],
			personas: [],
			operadores: [],
			articulosFase: [],
			articulosCodigos: [],
			articulosProducir: [],
			claves: [],
			areas: [],
			tipoSubparos: [],
			tipoParos: [],
			oeeFactores: [],
			previewVisible: false,
    		previewUrl: null,
			partes: [],
			loadingPartes: false,
			searchParte: "",
			parteTimer: null,
			tipoIncidencias: [
				//{
				//	id: true,
				//	text: "Paro",
				//},
				{
					id: false,
					text: "",
				},
			],
			filtros: {
				idTipoParo: null,
				idOEEFactor: -1,
				idParoTipo: null,
				idSubParoTipo: null,
				clave: null,
				idArticuloProducir: null,
				idArticuloFase: null,
				idArea: null,
				idReporto: null,
				idResponsable: null,
				inicio: null,
				fin: null,
				bloqueoProduccion: false,
				idArticuloCodigo: null,
			},
			series: [],
			chartOptions: null,
			loading: false,
			dialogVisible: false,
			selectedData: {
				category: '',
				serie: '',
				valor: 0,
			},
			paros: [], 
    		paros_total: 0,
    		paros_actual_page: 1,
    		paros_items_per_page: 10,
			parosRelacionados: [], 
			headersFiltrados: [],
		};
	},
	created() {
		this.applyI18nLabels();
	},
	computed: {
		...mapState({
			nombreEmpresa: "nombreEmpresa"
		}),
		currentLocale() {
			return this.$i18n.locale;
		},
		subTipoParoFiltrados() {
			if (this.$utils.isValid(this.filtros.idParoTipo))
				return this.tipoSubparos.filter(
					(tp) => tp.idParoTipo == this.filtros.idParoTipo
				);
			else return this.tipoSubparos;
		},
		tipoParosFiltrados() {
			if (
				this.$utils.isValid(this.filtros.idOEEFactor) &&
				this.filtros.idOEEFactor >= 0
			) {
				const idOEEFactor =
					this.filtros.idOEEFactor == 0
						? null
						: this.filtros.idOEEFactor;
				return this.tipoParos.filter(
					(tp) => tp.idOEEFactor == idOEEFactor
				);
			} else {
				return this.tipoParos;
			}
		},
	},
	watch: {
		'$i18n.locale'() {
			this.applyI18nLabels();
			this.paros = this.paros.map((paro) => this.mapParoRelacionado(paro));
		},
	},
	beforeMount() {
		this.setDefaultsChart();
	},
	mounted() {
		this.initialize();
	},
	methods: {
		nombrePersona: (persona) =>
			persona.nombre + " " + persona.paterno + " " + persona.materno,
		setLocale(locale) {
			if (!locale) return;
			this.$i18n.locale = locale;
			localStorage.setItem('locale', locale);
		},
		applyI18nLabels() {
			this.tipoIncidencias = this.tipoIncidencias.map((tipo) => ({
				...tipo,
				text: tipo.id === false ? this.$t('Reports.IncidentReport.values.report') : tipo.text,
			}));
			this.oeeFactores = this.oeeFactores.map((factor) => factor.idOEEFactor === 0
				? {
					...factor,
					nombre: this.$t('Reports.IncidentReport.values.unspecified'),
					descripcion: this.$t('Reports.IncidentReport.values.unspecifiedDescription'),
				}
				: factor);
			this.headersFiltrados = [
				{ text: this.$t('Reports.IncidentReport.table.partNumber'), value: "articuloProducir", align: "center" },
				{ text: this.$t('Reports.IncidentReport.table.item'), value: "codigoArticulo", align: "center" },
				{ text: this.$t('Reports.IncidentReport.table.modality'), value: "tipoIncidencia", align: "center" },
				{ text: this.$t('Reports.IncidentReport.table.type'), value: "motivoParo", align: "center" },
				{ text: this.$t('Reports.IncidentReport.table.process'), value: "proceso", align: "center" },
				{ text: this.$t('Reports.IncidentReport.table.reportedBy'), value: "reportadoPorOperadores", align: "center" },
				{ text: this.$t('Reports.IncidentReport.table.machine'), value: "maquina", align: "center" },
				{ text: this.$t('Reports.IncidentReport.table.start'), value: "inicio", align: "center", width: '9%' },
				{ text: this.$t('Reports.IncidentReport.table.end'), value: "fin", align: "center", width: '9%' },
				{ text: this.$t('Reports.IncidentReport.table.actions'), value: "actions", align: "center", sortable: false, width: '7%' },
			];
		},
		mapParoRelacionado(p) {
			const notAvailable = this.$t('Reports.IncidentReport.values.notAvailable');
			return {
				...p,
				proceso: `${this.$t('Reports.IncidentReport.values.phase')}: ${p.articuloFase || notAvailable}`,
				reportadoPorOperadores: (p.reportadoPor?.length > 0) ? p.reportadoPor : (p.operadoresReales?.length > 0 ? p.operadoresReales : [this.$t('Reports.IncidentReport.values.undefined')]),
				maquina: {
					marca: p.marca || notAvailable,
					modelo: p.modelo || notAvailable,
					codigo: p.codigo || notAvailable
				}
			};
		},
		initialize() {
			this.getSeries();
			this.getOEEFactores();
			this.getTipoParos();
			this.getTipoSubParos();
			this.getPersonas();
			this.getOperadores();
			this.getClaves();
			this.getArticulosProducir();
			this.getArticulosFase();
			this.getArticulosCodigo();
			this.getAreas();
			this.getInstancias();
		},
		getPersonas() {
			axios
				.get("/Personas")
				.then((response) => {
					this.personas = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getOperadores() {
			axios
				.get("/Personas/Operadores")
				.then((response) => {
					this.operadores = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getArticulosFase() {
			axios
				.get("/Articulos/ArticulosNombres?componentes=true")
				.then((response) => {
					this.articulosFase = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getArticulosCodigo() {
			axios
				.get("/Articulos/ArticulosNombres?componentes=true")
				.then((response) => {
					this.articulosCodigos = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getArticulosProducir() {
			axios
				.get("/Articulos/OTS")
				.then((response) => {
					this.articulosProducir = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getClaves() {
			axios
				.get("/TrabajoOrdenes/TrabajoOrdenHeaders")
				.then((response) => {
					this.claves = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getAreas() {
			axios
				.get("/Areas")
				.then((response) => {
					this.areas = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getTipoSubParos() {
			axios
				.get("/SubParoTipos")
				.then((response) => {
					this.tipoSubparos = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		changeParoTipo() {
			this.filtros.idSubParoTipo = null;
			this.getSeries();
		},
		getTipoParos() {
			axios
				.get("/ParoTipos")
				.then((response) => {
					this.tipoParos = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getInstancias(){
			axios
				.get("/MaquinaInstancias")
				.then( response => {
					this.instancias = response.data;
				})
				.catch( error => {
					console.log(error);
				})
		},
		getOEEFactores() {
			axios
				.get("/OEEFactores")
				.then((response) => {
					this.oeeFactores = response.data;
					this.oeeFactores.push({
						idOEEFactor: 0,
						nombre: this.$t('Reports.IncidentReport.values.unspecified'),
						descripcion: this.$t('Reports.IncidentReport.values.unspecifiedDescription'),
					});
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getSeries() {
			this.loading = true;

			axios
				.get("/Paros/GraficaParos", {
					params: {
						paginar: false,
						idParoTipo: this.filtros.idParoTipo,
						idSubParoTipo: this.filtros.idSubParoTipo,
						idTrabajoOrden: this.filtros.clave,
						idArticuloProducir: this.filtros.idArticuloProducir,
						idArticuloFase: this.filtros.idArticuloFase,
						idArticuloCodigo: this.filtros.idArticuloCodigo,
						idArea: this.filtros.idArea,
						idReporto: this.filtros.idReporto,
						idResponsable: this.filtros.idResponsable,
						idOEEFactor: this.filtros.idOEEFactor,
						bloqueoProduccion: this.filtros.bloqueoProduccion,
						inicio: this.filtros.inicio,
						fin: this.filtros.fin,
						tipoParo: this.filtros.idTipoParo,
						idMaquinaIns: this.filtros.instancias,
					},
				})
				.then((response) => {
					this.setDefaultsChart(response.data.categories);
					this.series = response.data.series;
				})
				.catch((error) => {
					this.setDefaultsChart();
					this.series = [];
				})
				.finally(() => {
					this.loading = false;
				});
		},
		descargarPDF(idParo) {
			const url = `/Paros/ReportePDFImagenes?IdParo=${idParo}`;
			const fileName = `ReporteParo.pdf`;
			this.$utils.axios.downloadFile(
				url,
				"GET",
				fileName, // Nombre del archivo con ID y fecha
				"application/pdf" // Tipo MIME para PDF
			);
		},
		setDefaultsChart(categories = []) {
			this.chartOptions = {
				chart: {
					type: "bar",
					height: 450,
					stacked: true,
					events: {
						dataPointSelection: async (event, chartContext, config) => {
							const categoria = this.chartOptions.xaxis.categories[config.dataPointIndex];
							const serie = this.series[config.seriesIndex].name;
							const valor = this.series[config.seriesIndex].data[config.dataPointIndex];
							const idParoTipo = this.series[config.seriesIndex].metaData?.[config.dataPointIndex];

							this.selectedData = { category: categoria, serie, valor };

							// Abre el diálogo de inmediato
							this.dialogVisible = true;

							// Prepara loading y limpia datos
							this.loading = true;
							this.paros = [];
							this.paros_total = 0;

							try {
								const response = await axios.get("/Paros/GraficaParosFotos", {
								params: {
									paginar: false,
									idParoTipo: idParoTipo,
									idSubParoTipo: this.filtros.idSubParoTipo,
									idTrabajoOrden: this.filtros.clave,
									idArticuloProducir: this.filtros.idArticuloProducir,
									idArticuloFase: this.filtros.idArticuloFase,
									idArea: this.filtros.idArea,
									idReporto: this.filtros.idReporto,
									idResponsable: this.filtros.idResponsable,
									idOEEFactor: this.filtros.idOEEFactor,
									bloqueoProduccion: this.filtros.bloqueoProduccion,
									inicio: this.filtros.inicio,
									fin: this.filtros.fin,
									tipoParo: this.filtros.idTipoParo,
									idMaquinaIns: this.filtros.instancias,
								},
								});

								this.paros = (response.data || []).map((p) => this.mapParoRelacionado(p));
								this.paros_total = this.paros.length;
  								this.paros_actual_page = 1;
							} catch (error) {
								console.error(this.$t('Reports.IncidentReport.errors.relatedReports'), error);
							} finally {
								this.loading = false;
							}
						}
					},
					toolbar: {
						show: true,
					},
					zoom: {
						enabled: true,
					},
				},
				responsive: [
					{
						breakpoint: 480,
						options: {
							legend: {
								position: "bottom",
								offsetX: -10,
								offsetY: 0,
							},
						},
					},
				],
				plotOptions: {
					bar: {
						horizontal: false,
						dataLabels: {
							total: {
								enabled: true,
								style: {
									fontSize: "13px",
									fontWeight: 900,
								},
							},
						},
					},
				},
				xaxis: {
					type: "category",
					categories,
				},
				legend: {
					position: "right",
					offsetY: 40,
				},
				fill: {
					opacity: 1,
				},
			};
		},
		async verParoPreview(idParo) {
			const res = await axios.get(`/Paros/PreviewParoPdf/${idParo}`, {
				responseType: 'blob'
			});
			const blob = new Blob([res.data], { type: 'application/pdf' });
			const url = URL.createObjectURL(blob);

			// Abre en nueva pestaña
			window.open(url, '_blank');
		}
	},
};
</script>
<style>
.incident-language-control {
	display: inline-flex;
	align-items: center;
	min-height: 40px;
	padding: 6px 10px;
	border: 1px solid #1976d2;
	border-radius: 6px;
	background: #f8fbff;
	box-shadow: 0 2px 8px rgba(25, 118, 210, 0.16);
}

.incident-language-toggle {
	border-radius: 4px;
	overflow: hidden;
	box-shadow: none !important;
}

.incident-language-toggle .incident-language-btn.v-btn {
	min-width: 44px !important;
	height: 30px !important;
	border: 1px solid #bbdefb !important;
	color: #1976d2 !important;
	background: #e3f2fd !important;
	font-weight: 700;
	letter-spacing: 0;
	opacity: 1 !important;
}

.incident-language-toggle .incident-language-btn.v-btn:not(.v-btn--active) {
	color: #1565c0 !important;
	background: #e3f2fd !important;
}

.incident-language-toggle .incident-language-btn.v-btn .v-btn__content {
	color: inherit !important;
	opacity: 1 !important;
}

.incident-language-toggle .incident-language-btn--active.v-btn,
.incident-language-toggle .incident-language-btn.v-btn.v-btn--active {
	border-color: #1976d2 !important;
	color: #ffffff !important;
	background: #1976d2 !important;
	box-shadow: none !important;
}
</style>
